/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { useGetCustomerBooking } from "../hooks/useGetCustomerBooking"
import { X } from "lucide-react"
import { Service, ServiceBooking } from "../types/service.type"
import moment from "moment"
import { currencyFormatter } from "../utils/formatter"
import Status from "./status"

export default function CustomerBookingList(
  { onClose }: { onClose: () => void }
) {
  const { bookings, getCustomerBooking } = useGetCustomerBooking()

  useEffect(() => {
    getCustomerBooking()
  }, [])

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden bg-transparent p-5">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2"></div>
        <h2 className="text-2xl font-bold">Booking History</h2>
        <div>
          <X className="w-6 h-6 cursor-pointer" onClick={onClose} />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-5 px-2">Booking Date Time</th>
            <th className="text-left py-5 px-2">Service(s)</th>
            <th className="text-right py-5 px-2">Price</th>
            <th className="text-center py-5 px-2">Status</th>
            <th className="text-center py-5 px-2">Payment Status</th>
          </tr>
        </thead>
        <tbody className="space-y-5 py-5">
          {bookings.map((booking: ServiceBooking) => (
            <tr
              key={booking.serviceBookingId}
              className="border-b border-gray-200 hover:bg-black/[0.02]"
            >
              <td className="text-left font-semibold py-5 px-2">{moment(booking.reservationDateTime).format("DD MMM YYYY HH:mm A")}</td>
              <td className="text-left py-5 px-2">{booking.serviceJson.map((service: Service) => service.title).join(", ")}</td>
              <td className="text-right py-5 px-2">{currencyFormatter(booking.totalPrice)}</td>
              <td className="text-center py-5 px-2"><Status status={booking.status} /></td>
              <td className="text-center py-5 px-2"><Status status={booking.paymentStatus} /></td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
